
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCautionGoogle as ObiCautionGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-caution-google.js';
 
 
 

 
 export const ObiCautionGoogle = createComponent({
   react: React,
   tagName: 'obi-caution-google',
   elementClass: ObiCautionGoogleElement,
   events: {
     
   }
  });
 
 